import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    }, theme: {
        themes: {
            light: {
                secondary: '#8b1b10',
                accent: '#0F428B',
                primary: '#460D08',
                error: '#FF5252',
                info: '#5FB1E1',
                success: '#4CAF50',
                warning: '#FFC107',
            }
        }
    }
});
